import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const addCourse = createAsyncThunk("admin/addCourse", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/course/add`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getCourses = createAsyncThunk("admin/allCourses", async ({ page, limit, searchData }, { rejectWithValue }) => {
  try {
    let url = `/course/all?`;
    if (page || limit) {
      url += `page=${page}&limit=${limit}`;
    }
    if (searchData) url += `&search=${searchData}`;
    const response = await apiInstance.get(url, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editCourse = createAsyncThunk("admin/editCourse", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/course/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getSingleCourse = createAsyncThunk("admin/singleCourse", async (courseId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/course/${courseId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteCourse = createAsyncThunk("admin/deleteCourse", async (selectedId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/course/delete/${selectedId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  courseData: [],
  singleCourseData: [],
};

const courseSlice = createSlice({
  name: "courseSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCourses.fulfilled, (state, action) => {
      state.courseData = action.payload.data;
    });
    builder.addCase(getSingleCourse.fulfilled, (state, action) => {
      state.singleCourseData = action.payload.data;
    });
  },
});

export default courseSlice.reducer;
